import { render, staticRenderFns } from "./TeamStats.vue?vue&type=template&id=78733e22&scoped=true&"
import script from "./TeamStats.vue?vue&type=script&lang=js&"
export * from "./TeamStats.vue?vue&type=script&lang=js&"
import style0 from "./TeamStats.vue?vue&type=style&index=0&id=78733e22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78733e22",
  null
  
)

export default component.exports